// extracted by mini-css-extract-plugin
module.exports = {"product-discontinued-warning":"product-discontinued-warning_product-discontinued-warning__zjygX"};